module.exports = __webpack_public_path__ + "static/media/9.355d0bb0.jpg";